import { ApprovalWorkflowSidebar } from 'app/domains/approval';
import { DocumentDrawerHeader } from 'shared/domains/documents';
import { DrawerContainer } from '../../styled';
import { getTitle } from '../../utils';
export function Approval(props) {
    const { onClose, onGoBack } = props;
    return (<DrawerContainer>
      <DocumentDrawerHeader type="nested" title={getTitle('approval')} onClose={onClose} onGoBack={onGoBack}/>
      <ApprovalWorkflowSidebar />
    </DrawerContainer>);
}
